import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../../utils/const";
import CandidateListCard from "./CandidateListCard";
import { useEffect, useState } from "react";
import {
  getAllRecruiterCandidateNextPrevious,
  getTrackerDetails,
} from "../../../redux/internal-tracking/InternalTrackerSlice";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField, Typography } from "@mui/material";
import styles from "../InternalTracker.module.css";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { getAllCandidate } from "../../../redux/candidate/candidateSlice";

const AddCandidateDrawerResumeProfile = ({
  handleClose,
  show,
  row,
  handleShowAdd,
}) => {
  const [searchData, setSearchData] = useState({
    full_name: "",
    email: "",
  });
  const [internalTrack, setInternalTrack] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const allCandiadate = useSelector((state) => state.candidate.data);
  const candidateStatus = useSelector((state) => state.candidate.status);

  useEffect(() => {
    dispatch(getAllCandidate());
  }, [dispatch]);

  useEffect(() => {
    if (allCandiadate) {
      setInternalTrack(allCandiadate?.profiles);
    }
  }, [allCandiadate]);

  const handleOnClickNextPrevious = (type) => {
    if (type === "next") {
      let url = allCandiadate?.next;
      dispatch(getAllRecruiterCandidateNextPrevious(url));
    } else {
      let url = allCandiadate?.previous;
      dispatch(getAllRecruiterCandidateNextPrevious(url));
    }
  };

  useEffect(() => {
    if (searchData) {
      const queryParams = Object.keys(searchData).reduce((acc, key) => {
        const value = searchData[key];
        if (Array.isArray(value) && value.length > 0) {
          // Send arrays as JSON strings
          acc[key] = JSON.stringify(value);
        } else if (
          value !== "" &&
          value !== null &&
          value !== undefined &&
          !Array.isArray(value)
        ) {
          // Include non-empty strings or numbers
          acc[key] = value;
        }
        return acc;
      }, {});

      // Convert queryParams into a query string
      const queryString = Object.entries(queryParams)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");

      // Dispatch the action with the query string
      dispatch(getAllCandidate(queryString));
    } else {
      dispatch(getAllCandidate(""));
    }
  }, [searchData, dispatch]);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "45%",
        padding: "0 0 0 10px",
        backgroundColor: "#fafafa",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid container sx={{ with: "90%" }}>
          <Grid item xs={12} sm={4} md={4} lg={4} sx={{ padding: "0 5px" }}>
            <Box>
              <Typography>Search by Name</Typography>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                placeholder="enter name..."
                sx={{ backgroundColor: "#fff", width: "100%" }}
                name="full_name"
                value={searchData.full_name || ""}
                onChange={(event) => {
                  setSearchData((prev) => ({
                    ...prev,
                    full_name: event.target.value,
                  }));
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4} sx={{ padding: "0 5px" }}>
            <Box>
              <Typography>Search by Email</Typography>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                placeholder="enter email..."
                sx={{ backgroundColor: "#fff", width: "100%" }}
                name="email"
                value={searchData.email || ""}
                onChange={(event) => {
                  setSearchData((prev) => ({
                    ...prev,
                    email: event.target.value,
                  }));
                }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={4}>
            <Box
              className={styles.search_btn}
              sx={{ position: "relative", top: "18px" }}
            >
              <button
                variant="contained"
                style={{ backgroundColor: "#0070c0", marginLeft: "10px" }}
                onClick={() => navigate("/internal-tracker-add")}
              >
                Upload Resume
              </button>
            </Box>
          </Grid>
        </Grid>
        <RxCross2
          style={{
            fontSize: "22px",
            with: "10%",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        {internalTrack?.map((candidate) => {
          return (
            <CandidateListCard
              candidate={candidate}
              handleShowAdd={handleShowAdd}
            />
          );
        })}

        <Box className={styles.candidateListing}>
          <button
            style={
              allCandiadate?.previous === null
                ? {
                    marginRight: "10px",
                    cursor: "not-allowed",
                  }
                : { marginRight: "10px" }
            }
            onClick={() => handleOnClickNextPrevious("previous")}
            disabled={allCandiadate?.previous === null}
          >
            {candidateStatus === "loading" ? "Loading" : "Prevoius"}
          </button>
          <button
            style={
              allCandiadate?.next === null
                ? {
                    marginRight: "0",
                    cursor: "not-allowed",
                  }
                : { marginRight: "0" }
            }
            onClick={() => handleOnClickNextPrevious("next")}
            disabled={allCandiadate?.next === null}
          >
            {candidateStatus === "loading" ? "Loading" : "Next"}
          </button>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddCandidateDrawerResumeProfile;
